'use strict'

const poolAbi = [
  {
    inputs: [],
    name: 'VERSION',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const getPoolVersion = function (web3, poolAddress) {
  const poolContract = new web3.eth.Contract(poolAbi, poolAddress)
  return poolContract.methods.VERSION().call()
}

module.exports = {
  getPoolVersion
}
